/* Zivlo: free-shipping progress in cart drawer and cart page. Threshold must match shipping rates. */
(function () {
  var THRESHOLD = 5000; // cents, A$50.00
  var busy = false;
  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function html(total) {
    var left = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / THRESHOLD) * 100)));
    var msg = left > 0
      ? "You're <strong>" + fmt(left) + '</strong> away from <strong>free AU shipping</strong>'
      : "You've unlocked <strong>free AU shipping</strong>";
    return '<div class="zv-ship" role="status">' + msg + '<div class="zv-ship__bar"><i style="width:' + pct + '%"></i></div></div>';
  }
  function targets() {
    return document.querySelectorAll('.cart-drawer__items, #MainContent .cart-items-component');
  }
  function render() {
    var t = targets();
    if (!t.length || busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        t.forEach(function (el) {
          var old = el.querySelector(':scope > .zv-ship');
          if (old) old.remove();
          if (cart.item_count > 0) el.insertAdjacentHTML('afterbegin', html(cart.total_price));
        });
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }
  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 150); }
  document.addEventListener('cart:update', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  new MutationObserver(function (muts) {
    function ours(list) {
      for (var j = 0; j < list.length; j++) {
        var x = list[j];
        if (!(x.nodeType === 1 && x.classList.contains('zv-ship')) && x.nodeType !== 3) return false;
      }
      return true;
    }
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i], n = m.target;
      if (ours(m.addedNodes) && ours(m.removedNodes)) continue;
      if (n.closest && !n.closest('.zv-ship') && n.closest('cart-drawer-component, .cart-items-component')) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
